"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var use_modal_toggle_state_hook_1 = __importDefault(require("../../hooks/use-modal-toggle-state.hook"));

var save_button_component_1 = __importDefault(require("../../common-components/save-button/save-button.component"));

var save_scenario_modal_component_1 = __importDefault(require("./save-scenario-modal.component"));

var SaveScenarioButton = function SaveScenarioButton(_ref) {
  var handleSaveScenario = _ref.handleSaveScenario;

  var _use_modal_toggle_sta = use_modal_toggle_state_hook_1.default(),
      modalProps = _use_modal_toggle_sta.modalProps,
      handleOpen = _use_modal_toggle_sta.handleOpen;

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(save_button_component_1.default, {
    onClick: handleOpen
  }, "\u4E0B\u66F8\u304D\u4FDD\u5B58"), react_1.default.createElement(save_scenario_modal_component_1.default, Object.assign({}, modalProps, {
    handleSaveScenario: handleSaveScenario
  })));
};

exports.default = SaveScenarioButton;